import { Sector } from "@/models/sector";
import { BaseModel } from "@/models/base";

export class UserGessan extends BaseModel {
  constructor(
    public sub: number,
    public nome?: string,
    public razaoSocial?: string,
    public nomeFantasia?: string,
    public cnpj?: string,
    public email?: String,
    public nomeResponsavel?: string,
    public cpfResponsavel?: string,
    public roles?: Array<string>,
    public isGrupo?: boolean
  ) {
    super(sub);
  }
}
